module.exports = __webpack_public_path__ + "img/travel_quote.cf6fcbed.png";